import React, { useState, useEffect, useContext } from "react";
import "react-toastify/dist/ReactToastify.css";
import { RootContext } from "../..";
import { observer } from "mobx-react-lite";
import { DataTable } from "./Table";
import { DataTable2 } from "./Table2";
import { DateInput } from "../Common/Form";
import { toJS } from "mobx"
import moment from "moment";
import "../RawData/rawData.css";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { Spinner } from "../Common/Spinner";

const RawData = observer(() => {

  const rootStore = useContext(RootContext);
  const rawDataStore = rootStore.rawDataStore;
  const deviceStore = rootStore.deviceStore;

  const [filters, setFilters] = useState({
    date_from: moment().utc().subtract(6, "days").format("YYYY-MM-DDTHH:mm:ss"),
    date_to: moment().utc().format("YYYY-MM-DDT23:59:59")
  });

  const [inputFieldValue, setinputFieldValue] = useState({
    mobileOwnerId: "",
    MobileId: ""
  });

  const [isLoading, setIsLoading] = useState(false)

  const [data, setData] = useState([]);
  const [decodedData, setDecodedData] = useState([]);
  const [refTime, setRefTime] = useState([]);

  useEffect(() => {
    if (!deviceStore.orbcommDevice || deviceStore.orbcommDevice.length === 0) rawDataStore.fetchOrbcommDevice();
    if (!deviceStore.gateWayAccount || deviceStore.gateWayAccount.length === 0) deviceStore.fetchGateWayAccount();
    if (!rawDataStore.time) rawDataStore.fetchReferenceTime();
  }, []);

  const setNewFilters = (filter, value) => {
    setFilters((prev) => ({ ...prev, [filter]: value }));
  };

  const setNewForm = (e) => {
    const { name, value } = e.target;

    if (name === "mobileOwnerId") {
      setinputFieldValue({
        mobileOwnerId: value,
        MobileId: ""
      });
    } else {
      setinputFieldValue((prev) => ({ ...prev, [name]: value }));
    }
  };

  const retrieveData = async (e) => {
    e.preventDefault();

    const { mobileOwnerId, MobileId } = inputFieldValue;
    setIsLoading(true)
    let obj = {
      datefrom: filters.date_from,
      dateto: filters.date_to,
      mobileOwnerId: mobileOwnerId,
      mobileid: MobileId
    };

    try {
      await rawDataStore.fetchRawData(obj);
      await rawDataStore.fetchDecodedData(obj);
      await rawDataStore.fetchReferenceTime(obj);

      let filteredData = rawDataStore.items.sort(
        (a, b) => new Date(a.receive_utc) - new Date(b.receive_utc)
      );

      let filteredData2 = rawDataStore.items2.sort(
        (a, b) => new Date(a.received) - new Date(b.received)
      );

      let referencetime = rawDataStore.time;

      setData(filteredData);
      setDecodedData(filteredData2);
      setRefTime(referencetime);
    } catch (error) {
      throw error
    } finally {
      setIsLoading(false)
    }

  };

  const mapValue = {
    '60003414': '25kb',
    '60003986': '50kb'
  }

  const uniqueAccounts = [...new Set(deviceStore?.gateWayAccount?.map(i => i.mobileownerid))]

  const serialNumbers = inputFieldValue.mobileOwnerId
    ? [
      ...new Map(
        (deviceStore.gateWayAccount || [])
          .filter((item) => item.mobileownerid === inputFieldValue.mobileOwnerId)
          .map(i => [i.serialNo, [i.serialNo, i.stationName]])
      ).values(),
    ]
    : [];

  return (
    <div className="w-full flex flex-col p-6 min-h-screen bg-gray-50">
      {/* Filter Card */}
      <div className="w-full bg-white rounded-lg shadow-md p-6 mb-6">
        <form className="flex flex-wrap items-center gap-6 justify-between">
          <div className="flex flex-wrap items-center gap-4">
            <Autocomplete
              size="small"
              options={uniqueAccounts}
              value={inputFieldValue.mobileOwnerId || null}
              onChange={(e, value) => setNewForm({ target: { name: "mobileOwnerId", value: value || "" } })}
              getOptionLabel={(account) => `${account} (${mapValue[account] || account})`}
              ListboxProps={{ style: { maxHeight: 300 } }}
              className="bg-white min-w-[250px]"
              renderInput={(params) => <TextField {...params} placeholder="Gateway Account" />}
            />

            {inputFieldValue.mobileOwnerId && (
              <Autocomplete
                size="small"
                options={serialNumbers}
                value={serialNumbers.find((serial) => serial[0] === inputFieldValue.MobileId) || null}
                onChange={(e, serial) => setNewForm({ target: { name: "MobileId", value: serial ? serial[0] : "" } })}
                getOptionLabel={(serial) => `${serial[1]} (${serial[0]})`}
                isOptionEqualToValue={(option, value) => option[0] === value[0]}
                ListboxProps={{ style: { maxHeight: 300 } }}
                className="bg-white min-w-[300px]"
                renderInput={(params) => <TextField {...params} placeholder="Serial Number" />}
              />
            )}

            <div className="flex items-center gap-2">
              <span className="text-sm font-medium text-gray-700">From:</span>
              <input
                type="date"
                value={moment(filters.date_from).format("YYYY-MM-DD")}
                onChange={(e) => setNewFilters("date_from", e.target.value)}
                className="border border-gray-300 rounded px-3 h-9 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
              />
            </div>

            <div className="flex items-center gap-2">
              <span className="text-sm font-medium text-gray-700">To:</span>
              <input
                type="date"
                value={moment(filters.date_to).format("YYYY-MM-DD")}
                onChange={(e) => setNewFilters("date_to", e.target.value)}
                className="border border-gray-300 rounded px-3 h-9 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
              />
            </div>
          </div>

          <button
            onClick={retrieveData}
            className="h-9 px-6 bg-blue-600 text-white rounded hover:bg-blue-700 transition font-medium"
          >
            Retrieve Data
          </button>
        </form>
      </div>
       {isLoading ? <Spinner/> : <>
         <div className="w-full bg-white rounded-lg shadow-md p-6 mb-6">
        <h2 className="text-lg font-bold text-gray-800 mb-4">Decoded Data</h2>
        <div className="w-full overflow-x-auto">
          <DataTable2
            data={decodedData}
            headers={["SN", "Terminal", "Received", "Beam", "LastResetReason"]}
          />
        </div>
      </div>

      <div className="w-full bg-white rounded-lg shadow-md p-6">
        <h2 className="text-lg font-bold text-gray-800 mb-4">User Data</h2>
        <div className="w-full overflow-x-auto">
          <DataTable
            data={data}
            refTime={refTime}
            headers={[
              "SN",
              "Mobileid",
              "Received",
              "Size",
              "SIN",
              "Region",
              "MobileOwnerId",
              "UserData",
              "UTC"
            ]}
            retrieveData={retrieveData}
          />
        </div>
      </div>
       </>
       }
    
    </div>
  );
});

export default RawData;